module.exports = __webpack_public_path__ + "img/logo-sicarf-dark.a85bc288.svg";